// extracted by mini-css-extract-plugin
export default {"error":"simpleSelect_error__T9oIk"};